module.exports = __webpack_public_path__ + "static/media/business_yin_yang.14a598b6.jpg";